import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

import { SUPPORT_SECTION_STICKY_ENABLED } from "@/config/app-constant";

interface UseStickyLayoutReturn {
  maxHeight: number;
  stickyStyles: React.CSSProperties;
  isMobileDevice: boolean;
  isStickyPage?: boolean;
  screenWidth: number;
}

function useStickyLayout(): UseStickyLayoutReturn {
  const [maxHeight, setMaxHeight] = useState(0);
  const [screenWidth, setScreenWidth] = useState(0);
  const [isMobileDevice, setIsMobileDevice] = useState(false);
  const pathname = usePathname();

  const trimmedPath = pathname.replace(/^\/|\/$/g, "");
  const isStickyPage = SUPPORT_SECTION_STICKY_ENABLED.includes(trimmedPath);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const userAgent =
        navigator.userAgent ||
        navigator.vendor ||
        (window as Window & typeof globalThis & { opera?: string }).opera ||
        "";
      const isAndroid = /android/i.test(userAgent);
      const isIOS =
        /iPad|iPhone|iPod/.test(userAgent) &&
        !(window as Window & { MSStream?: unknown }).MSStream;

      setIsMobileDevice(isAndroid || isIOS);
    }
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const updateHeight = () => {
        const availableHeight = window.innerHeight;
        setMaxHeight(availableHeight);
      };

      const updateWidth = () => {
        const availableWidth = window.innerWidth;
        setScreenWidth(availableWidth);
      };

      updateHeight();
      updateWidth();
      window.addEventListener("resize", updateHeight);

      return () => window.removeEventListener("resize", updateHeight);
    }
  }, []);

  const shouldApplyStickyStyles = !isMobileDevice;

  const stickyStyles: React.CSSProperties = shouldApplyStickyStyles
    ? {
        position: "sticky",
        maxHeight: `${maxHeight}px`,
        top: 0,
        bottom: 0,
        // overflowY: "scroll", // keep this commented line for future req changes
        WebkitOverflowScrolling: "touch",
        msOverflowStyle: "none",
        scrollbarWidth: "none",
      }
    : {};

  return {
    maxHeight,
    stickyStyles,
    isMobileDevice,
    isStickyPage,
    screenWidth,
  };
}

export default useStickyLayout;
